import React from "react";
import GoToPage from "./goToPage";

//por ahora no se usa
//usar para las que faltan en modo desktop
const GroupsLayeredTile = (props) => {
  const {
    ico,
    title,
    subTile,
    linkPage,
    linkSide,
    linkName,
    linkFontsize,
    linkTextColor,
    linkBorderType,
    linkBorderColor,
    linkIconSize,
    linkIconColor,
    linkIconMargin,
  } = props;
  return (
    <div className=" grid grid-cols-3 items-center relative z-10">
      <div className="grid grid-rows-2 col-span-2">
        <div className="relative pt-10  w-full">
          <h1 className="text-5xl font-bold pl-10 absolute">{title}</h1>
        </div>
        <div className="mt-20 pl-10">
          <GoToPage
            page={linkPage}
            side={linkSide}
            name={linkName}
            fontSize={linkFontsize}
            textColor={linkTextColor}
            borderType={linkBorderType}
            borderColor={linkBorderColor}
            iconSize={linkIconSize}
            iconColor={linkIconColor}
            iconMargin={linkIconMargin}
          ></GoToPage>
        </div>
      </div>

      <div className="right-0 mr-10 absolute ">
        <img loading="lazy" src={ico} className="mb-24"></img>
      </div>
    </div>
  );
};

export default GroupsLayeredTile;
